import moment from 'moment-timezone';

import { isNameValid, isNPIValid } from 'common-src/utils/validationUtils';

export const validatePatientGuideCmsAlignment = (field, value) => {
  let errMsg = '';
  switch (field) {
    case 'unEffectiveDate':
    case 'assessmentDate':
      if (value === undefined) {
        errMsg = 'Invalid date format';
      } else if (value && moment(value).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
        errMsg = 'Date should not be in the future';
      }
      break;
    case 'npi':
      if (value && !isNPIValid(value)) {
        errMsg = 'NPI is not valid';
      }
      break;
    case 'clinicianFirstName':
      if (value && !isNameValid(value)) {
        errMsg = 'Invalid first name';
      } else if (value && value.length > 35) {
        errMsg = 'First name should be a maximum of 35 characters';
      }
      break;
    case 'clinicianMiddleName':
      if (value && !isNameValid(value)) {
        errMsg = 'Invalid middle name';
      } else if (value && value.length > 35) {
        errMsg = 'Middle name should be a maximum of 35 characters';
      }
      break;
    case 'clinicianLastName':
      if (value && !isNameValid(value)) {
        errMsg = 'Invalid last name';
      } else if (value && value.length > 35) {
        errMsg = 'Last name should be a maximum of 35 characters';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
